// extracted by mini-css-extract-plugin
module.exports = {"image":"CreditCard_image__UyoSb","name":"CreditCard_name__22V7I","nameSmall":"CreditCard_nameSmall__2J6Ph","black":"CreditCard_black__2w7gv"};